import {OpeningTimes} from "@/components/OpeningTimes/ValueObject/OpeningTimes";

export default class DefaultState {
  loading = false;
  activeFranchise: null|string = null;
  franchiseOpeningTimes: OpeningTimes[] = [];
  addClosedDateModal = false;
  addingClosedDateError: string|null = null;
}
